'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dCode$0024 from "./presto.types$-Policy-Code$.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dId$0024 from "./presto.types$-Policy-Id$.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dName$0024 from "./presto.types$-Policy-Name$.js";
import * as $j_presto$002etypes$0024$002dRule$002dId$0024 from "./presto.types$-Rule-Id$.js";
import * as $j_presto$002etypes$0024$002dSite$002dId$0024 from "./presto.types$-Site-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_PolicyView$$anon$1(outer) {
  this.bas = null;
  this.baq = null;
  this.bar = false;
  this.bao = null;
  this.bap = false;
  this.bat = false;
  this.bau = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bas = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PolicyView$$anon$1 as $c_Lpresto_PolicyView$$anon$1 };
$p = $c_Lpresto_PolicyView$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PolicyView$$anon$1;
/** @constructor */
function $h_Lpresto_PolicyView$$anon$1() {
}
export { $h_Lpresto_PolicyView$$anon$1 as $h_Lpresto_PolicyView$$anon$1 };
$h_Lpresto_PolicyView$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bas;
});
$p.t = (function() {
  if ((!this.bar)) {
    this.baq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("groups", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("rules", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.bar = true;
  }
  return this.baq;
});
$p.ae = (function() {
  if ((!this.bap)) {
    this.bao = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPolicy$002dId$0024.$m_Lpresto_types$PolicyId$().cIi(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPolicy$002dCode$0024.$m_Lpresto_types$PolicyCode$().adB(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPolicy$002dName$0024.$m_Lpresto_types$PolicyName$().cIj(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().gJ()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().jV()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dRule$002dId$0024.$m_Lpresto_types$RuleId$().a2F()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dSite$002dId$0024.$m_Lpresto_types$SiteId$().sE()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.bap = true;
  }
  return this.bao;
});
$p.w = (function() {
  if ((!this.bau)) {
    this.bat = false;
    this.bau = true;
  }
  return this.bat;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PolicyView$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PolicyView$$anon$1, "presto.PolicyView$$anon$1", ({
  N2: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PolicyView$$anon$1 as $d_Lpresto_PolicyView$$anon$1 };
//# sourceMappingURL=presto.-Policy-View$$anon$1.js.map
